/** @override King Living: IconSetFragment with appearance-driven CF-053 / CF-054 layouts. */

import gql from 'graphql-tag';

import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseIconSetFragment} from '@amblique/king-living/app/contentful/fragments/icon-set/base-icon-set.fragment';

export const IconSetFragment = gql`
  ${BaseIconFragment}
  ${BaseIconSetFragment}

  fragment IconSetFragment on IconSet {
    ...BaseIconSetFragment

    iconsCollection {
      items {
        __typename
        ... on Icon {
          ...BaseIconFragment
        }
      }
    }
  }
`;
